import React, { useEffect, useState } from 'react';
import { DashboardApis } from 'hooks/apis/DashboardApis';
import StatTile from '../../../components/common/StatTile';

const UserAverageTatTile = () => {
  const [value, setValue] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const { getUserAverageTat } = DashboardApis();

  useEffect(() => {
    getUserAverageTat()
      .then((data) => {
        if (data && !data.errorMessage) {
          setValue(data);
        } else if (data?.errorMessage) {
          setError(data.errorMessage);
        }
      })
      .finally(() => setLoading(false));
  }, [getUserAverageTat]);

  return (
    <StatTile
      label="Average TAT"
      value={value !== null ? value.toFixed(1) : '-'}
      suffix=" days"
      loading={loading}
      error={error}
    />
  );
};

export default UserAverageTatTile;